import { CaseCard } from '@components/case_card.component';
import { Icon } from '@components/icon.component';
import { AttentionCardCaseCardWrapper } from './_attention_card_case_card_wrapper.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import type { AttentionCardAppointmentCaseModel } from '@components/attention_card/_attention_card.controller';

interface Props {
	case: AttentionCardAppointmentCaseModel;
}

export function AttentionCardTypeUnpaid({ case: $case }: Props): JSX.Element {
	return (
		<AttentionCardCaseCardWrapper
			to={$case.link}
			alertiveTitle
			description={withTranslation('PW.Component.AttentionCard.Unpaid.Description')}
			ariaLabel={withTranslation('PW.Component.AttentionCard.Unpaid.Aria', { date: $case.dateFormatted })}
			analyticAction='Clicked Unpaid appointment-card'
		>
			<CaseCard>
				<CaseCard.Thumbnail size={30} type='alertive'>
					<Icon type='alertiveCreditCard' />
				</CaseCard.Thumbnail>
				<CaseCard.Title>{withTranslation('PW.Component.AttentionCard.Unpaid.Subject')}</CaseCard.Title>
				<CaseCard.Date>{withTranslation('PW.Component.AttentionCard.Unpaid.DueDate', { date: $case.dateFormatted })}</CaseCard.Date>
				<CaseCard.Icon>
					<Icon type='attentionCardArrow' />
				</CaseCard.Icon>
			</CaseCard>
		</AttentionCardCaseCardWrapper>
	);
}
